import { createAsyncThunk,createSlice } from '@reduxjs/toolkit'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import { parseCollectionSnapshot } from '../../utils/firebaseUtils'

const name = `faqs`
let unsubscribe

export const subscribeToFaqs = createAsyncThunk(`${name}/subscribe`,async(_,{ getState,dispatch }) => {
  if(unsubscribe) unsubscribe()
  unsubscribe = firebase.firestore().collection(name).onSnapshot(snapshot => {
    dispatch(setFaqs(parseCollectionSnapshot(snapshot)))
  })
})

const slice = createSlice({
  name,
  initialState: {
    status: `idle`,
    data: [],
    error: null,
  },
  reducers: {
    setFaqs(state,action){
      state.data = action.payload
    },
  },
})

export default slice.reducer
export const { setFaqs } = slice.actions
export const selectFaqsSlice = state => state[name]
export const selectFaqs = state => state[name].data

